import { DenominacoesTableRow } from './auxiliarDenominacoesGenericas';

const isSim = (valor?: string): boolean => valor === 'S';

export const buildDenominacoesTableData = (
  data: any[],
  getTipoProdutoLabel: (item: any) => string,
): DenominacoesTableRow[] => {
  return data.map((item) => ({
    id: item?.id ?? 'Não informado',

    tipoProduto: item.tipoProduto ? getTipoProdutoLabel(item) : 'Não informado',
    dcb: item?.dcb ?? 'Não informado',
    compBasico: isSim(item?.compBasico),
    compEspecializado: isSim(item?.compEspecializado),
    compEstrategico: isSim(item?.compEstrategico),
    compOncologico: isSim(item?.compOncologico),
    compRara: isSim(item?.compRara),

    denominacaoGenerica: item?.denominacaoGenerica ?? 'Não informado',
  }));
};
